// hooks/signalr/useSignalRHeartbeat.js
import { useEffect, useRef, useCallback } from 'react';
import * as signalR from '@microsoft/signalr';
import { HEARTBEAT_CONFIG } from './signalRConfig';

export const useSignalRHeartbeat = (connectionRef, setIsConnected) => {
  const heartbeatIntervalRef = useRef(null);
  const httpHeartbeatIntervalRef = useRef(null);

  // ========== HTTP HEARTBEAT ==========
  const sendHTTPHeartBeat = useCallback(async () => {
    try {
      await fetch('/api/heartbeat', {
        method: 'GET',
        cache: 'no-cache'
      });

      setIsConnected(true);
    } catch (error) {
      console.error('HTTP heartbeat failed:', error);
      setIsConnected(false);
    }
  }, [setIsConnected]);

  // ========== SIGNALR PING/PONG ==========
  const startSignalRHeartbeat = useCallback(() => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
    }

    heartbeatIntervalRef.current = setInterval(async () => {
      if (connectionRef.current?.state === signalR.HubConnectionState.Connected) {
        try {
          await connectionRef.current.invoke('Ping');
        } catch (err) {
          console.error('Heartbeat failed:', err);

          // Försök återansluta om vi förlorat anslutningen
          if (connectionRef.current?.state !== signalR.HubConnectionState.Connected) {
            try {
              await connectionRef.current?.start();
            } catch (reconnectErr) {
              console.error('Reconnect failed:', reconnectErr);
            }
          }
        }
      }
    }, HEARTBEAT_CONFIG.pingInterval);
  }, [connectionRef]);

  const stopSignalRHeartbeat = useCallback(() => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
      heartbeatIntervalRef.current = null;
    }
  }, []);

  // ========== HTTP HEARTBEAT INTERVAL ==========
  useEffect(() => {
    // Skicka HTTP heartbeat var 5:e minut
    httpHeartbeatIntervalRef.current = setInterval(
      sendHTTPHeartBeat,
      HEARTBEAT_CONFIG.httpInterval
    );

    return () => {
      if (httpHeartbeatIntervalRef.current) {
        clearInterval(httpHeartbeatIntervalRef.current);
      }
    };
  }, [sendHTTPHeartBeat]);

  return {
    sendHTTPHeartBeat,
    startSignalRHeartbeat,
    stopSignalRHeartbeat
  };
};